/// <reference types="google.maps" />

import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { MapsMarkConfig, MapsMarkComponent } from './maps-mark.component';

@Injectable()
export class MapsMarkService {
  constructor(
    private modalService: BsModalService
  ) { }

  public show(config: MapsMarkConfig): Promise<google.maps.LatLngLiteral> {
    const modalClass = `modal-${config.modalClass || 'lg'}`;
    return new Promise((resolve, reject) => {
      const modal = this.modalService.show(MapsMarkComponent, { class: modalClass });
      modal.content.setOption(resolve, reject, config);
    });
  }
}
